import { login } from './login'
import * as sfBankAccounts from './sf-bank-accounts'
import * as sfWallets from './sf-wallets'
import * as userBankAccounts from './user-bank-accounts'
import * as userWallets from './user-wallets'
import * as introducer from './introducer'
import * as commissions from './commissions'
import * as auditLogs from './audit-logs'
import * as businessEntities from './business-entities'
import * as clientTypes from './client-types'
import * as assets from './assets'
import * as users from './users'
import * as generalSettings from './general-settings'
import * as transactions from './transactions'
import * as fireblocks from './fireblocks'
import * as crmRules from './crm-rules'

export default {
  login,
  ...sfBankAccounts,
  ...sfWallets,
  ...userBankAccounts,
  ...userWallets,
  ...introducer,
  ...commissions,
  ...auditLogs,
  ...businessEntities,
  ...clientTypes,
  ...assets,
  ...users,
  ...generalSettings,
  ...transactions,
  ...fireblocks,
  ...crmRules,
}
